import type { FirestoreUserProfile } from "~/services/server/user-tenant/getUserInfoWithLambda";
import type { FirestoreUserProfileDisplay } from "~/components/Layout/MainLayout/MainLayout";

export function mapFirestoreProfileToDisplay(
  profile: FirestoreUserProfile | null | undefined
): FirestoreUserProfileDisplay | null {
  if (!profile) return null;
  return {
    username: profile.username,
    email: profile.email,
    firstName: profile.firstName,
    lastName: profile.lastName,
    profilePictureUrl: profile.profilePictureUrl,
  };
}
